import React from 'react'
import CollagesList from '../../components/admin/CollagesList'

export default function CollageList() {
  return (
    <div>
        <>
            <CollagesList/>
        </>
    </div>
  )
}
